import $ from 'jquery';

export default {
    autoWidth: false,
    ordering: false,
    paging: false,
    paginationType: 'full_numbers',
    info: false,
    searching: false,
    processing: false,
    lengthChange: false,
    pageLength: 25,
    responsive: {
        auto: true,
        details: {
            type: 'inline',
            target: '1',
            renderer: (api, rowIdx) => {
                const mapper = function (cell) {
                    const header = $(api.column(cell.column).header());
                    const cn = $(api.cell(cell).nodes()).attr('class') || '';
                    return `
                        <div class="row ${header.attr('class')}">
                            <div class="cell-label">${header.text()}</div>
                            <div class="cell-value ${cn}">${api.cell(cell).data()}</div>
                         </div>
                    `;
                };
                const data = api.cells(rowIdx, ':hidden').eq(0).map(mapper).toArray().join('');
                return data ? $('<div />').append(data) : false;
            }
        }
    },
    hasBootstrap: true
};



// WEBPACK FOOTER //
// ./src/app/constants/datatables/index.js